import { useEffect, useContext } from 'react';

import Cookies from 'js-cookie';
import { useRouter } from 'next/router';

import { MeContext } from '~/contexts/MeContext';

export const useTrackCLID = () => {
  const router = useRouter();
  const { me } = useContext(MeContext);
  const userID = me?.id;

  useEffect(() => {
    let GCLID = router.query?.gclid;
    let FBCLID = router.query?.fbclid;

    if (GCLID) {
      GCLID = String(router.query?.gclid);
      Cookies.set('gclid', GCLID, { expires: 90 });
      // storing click ID in amplitude for a user if logged in
      userID && window.analytics.identify(userID, { gclid: GCLID });
    }

    if (FBCLID) {
      FBCLID = String(router.query?.fbclid);
      Cookies.set('fbclid', FBCLID, { expires: 90 });
      // storing click ID in amplitude for a user if logged in
      userID && window.analytics.identify(userID, { fbclid: FBCLID });
    }
  }, [router.query?.gclid, router.query?.fbclid, userID]);
};
